
import common_pdd from './common_pdd';
import common from "../js/common";
import {get, post, postJson} from "../js/http";
import md5 from "js-md5";
import {formatData} from "../js/utils";
import {Toast} from 'vant';

// export function getSelectGoodsParams_pdd() {
//     return {
//
//     }
// }

export function getSelectGoods_pdd_2(paramsData, fn) {
    paramsData = {
        "catid": "0",
        "rnum": "12345678",
        "md5": "8ab291b1873bb5eb648bcd38e394264a"
    };

    let url = 'https://api.wapg.cn/openpdd/GoodsCatsGet';
    postJson(url, paramsData).then(function (response) {
        if (fn) {
            fn(response);
        }
    }, function (err) {
        fn(err)
    })
}

/**
 * 获取拼多多的商品列表
 * @param paramsData
 * @param fn
 */
export function getSelectGoods_pdd(paramsData, fn) {
    let pid = paramsData.pid;
    if (pid) {
        let randomNum = common.getRandom();
        let _md5 = md5(pid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let url = common_pdd.get_select_goods;
        let params = common.copyObj(paramsData)

        postJson(url, params).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 获取拼多多的爆款列表
 * @param paramsData
 * @param fn
 */
export function getTopGoods_pdd(paramsData, fn) {
    let pid = paramsData.pid;
    if (pid) {
        let randomNum = common.getRandom();
        let _md5 = md5(pid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let url = common_pdd.get_top_goods;
        let params = common.copyObj(paramsData)

        postJson(url, params).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 获取拼多多的类目数据
 * @param paramsData
 * @param fn
 */
export function getGoodsCats_pdd(paramsData, fn) {
    let catid  = paramsData.catid;
    let randomNum = common.getRandom();
    let _md5 = md5(catid  + randomNum + common.key).toLowerCase();
    paramsData.md5 = _md5;
    paramsData.rnum = randomNum;

    let url = common_pdd.get_goods_cats;
    let params = common.copyObj(paramsData)

    postJson(url, params).then(function (response) {
        if (fn) {
            fn(response);
        }
    }, function (err) {
        fn(err)
    })
}

/**
 * 获取拼多多的推广位id
 * @param paramsData
 * @param fn
 */
export function getPinduoduoPid_pdd(paramsData, fn) {
    let p_id_name_list  = paramsData.p_id_name_list;
    if(p_id_name_list) {
        let number = paramsData.number;
        let randomNum = common.getRandom();
        let _md5 = md5(number + p_id_name_list + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let url = common_pdd.get_pingduoduo_pid;
        let params = common.copyObj(paramsData)

        postJson(url, params).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })
    }else{
        Toast.fail({
            message: '会员编号异常，请退出重新登录'
        })
    }
}


/**
 * 获取商品详情数据
 * @param paramsData
 * @param fn
 */
export function getSkuDetailData_pdd(paramsData, fn) {

    let num_iids = paramsData.num_iids;
    if (num_iids) {
        let randomNum = common.getRandom();
        let _md5 = md5(randomNum + common.key).toLowerCase();
        this.$log("md5 --- " + _md5)
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData, 'canNull');
        this.$log(param);
        let url = common_pdd.get_sku_detail_data + "?" + param;

        get(url).then(function (response) {
            if (fn) {
                fn(response);
            }
        })
    }
}


export function getExtendLinkParams_pdd() {
    return {
        pid: "",
        goods_sign_list: "",//商品ID，仅支持单个查询
        gshort_url: true,//是否生成短链接，true-是，false-否
        multi_group: false,//true--生成多人团推广链接 false--生成单人团推广链接（默认false）1、单人团推广链接：用户访问单人团推广链接，可直接购买商品无需拼团。2、多人团推广链接：用户访问双人团推广链接开团，若用户分享给他人参团，则开团者和参团者的佣金均结算给推手
        custom_parameters: common.getUsername(),//自定义参数，为链接打上自定义标签。自定义参数最长限制64个字节。
        g_wx_webview: true,//是否生成唤起微信客户端链接，true-是，false-否，默认false
        zs_duo_id: -1,//招商多多客ID
        generate_we_app: true,//是否生成小程序推广
        g_wb_webview: true,//是否生成微博推广链接
        g_cl_coupon: true,//是否生成店铺收藏券推广链接
        g_schema_url: true,//是否返回 schema URL
        g_qq_app: true,//是否生成qq小程序
        search_id: "",//搜索id，必填，否则影响收益
    }
}

/**
 * 获取拼多多推广链接
 * @param paramsData
 * @param fn
 */
export function getExtendLink_pdd(paramsData, fn) {

    let pid = paramsData.pid;
    if (pid) {

        let goods_sign_list = paramsData.goods_sign_list;
        // let search_id = paramsData.search_id;

        let randomNum = common.getRandom();
        let _md5 = md5(pid + goods_sign_list + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        // let param = formatData(paramsData, 'canNull');
        // this.$log(param);
        let url = common_pdd.make_pdd_links;

        let params = common.copyObj(paramsData)

        postJson(url, params).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })
    }
}


/**
 * 获取订单列表
 * @param paramsData
 * @param fn
 */
export function getOrderList_pdd(paramsData, fn) {

    let pid = paramsData.pid;
    if(pid){
        let randomNum = common.getRandom();
        let _md5 = md5(pid + randomNum + common.key).toLowerCase();
        this.$log("md5 --- " + _md5)
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData, 'canNull');
        this.$log(param);
        let url = common_pdd.get_order_list + "?" + param;

        get(url).then(function (response) {
            if (fn) {
                fn(response);
            }
        })
    }else{
        Toast.fail({
            message: 'pid为空'
        })
        if (fn) {
            fn(null);
        }
    }
}

/**
 * 获取订单列表(完成时间)
 * @param paramsData
 * @param fn
 */
export function getOrderByFinish_pdd(paramsData, fn) {

    let pid = paramsData.pid;
    if (pid) {
        let randomNum = common.getRandom();
        let _md5 = md5(pid + randomNum + common.key).toLowerCase();
        this.$log("md5 --- " + _md5)
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData, 'canNull');
        this.$log(param);
        let url = common_pdd.get_order_by_Finish + "?" + param;

        get(url).then(function (response) {
            if (fn) {
                fn(response);
            }
        })
    }
}

/**
 * 收入统计接口
 * @param paramsData
 * @param fn
 */
export function getIncometByData_pdd(paramsData, fn) {
    // pid:推荐位ID 必须
    // stime:开始时间 默认当天
    // etime:结束时间  默认当天
    let spid = paramsData.pid;
    if (spid) {
        let randomNum = common.getRandom();
        let _md5 = md5(spid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;
        let param = formatData(paramsData);
        let url = common_pdd.order_count_new + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        })
    }
}

/**
 * 获取每日预估收入的列表
 * @param paramsData
 * @param fn
 */
export function getEverydayCountList_pdd(paramsData, fn) {
    // uid:群号 必须
    // stime:开始时间 默认当天
    // etime:结束时间  默认当天
    let uid = paramsData.uid;
    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;
        let param = formatData(paramsData);
        let url = common_pdd.get_everyday_count_list + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 群下级人数及收入
 * @param paramsData
 * @param fn
 */
export function getLevelCountData_pdd(paramsData, fn) {

    let uid = paramsData.uid;
    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;
        let param = formatData(paramsData);
        let url = common_pdd.level_count_data + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        })
    }
}

/**
 * 代理通过下级和下下级所能获得的佣金提成的集合
 * @param paramsData
 * @param fn
 */
export function getPidLevelCountList_pdd(paramsData, fn) {
    let u_mark = paramsData.u_mark;
    if (u_mark) {
        let randomNum = common.getRandom();
        let _md5 = md5(u_mark + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_pdd.pid_level_count_list + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 用户可提款金额
 * @param paramsData
 * @param fn
 */
export function getUserPayTo_pdd(paramsData, fn) {
    let spid = paramsData.uid;
    if (spid) {
        let randomNum = common.getRandom();
        let _md5 = md5(spid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_pdd.user_pay_to + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        })
    }
}

/**
 * 用户可提款明细
 * @param paramsData
 * @param fn
 */
export function getUserPayList_pdd(paramsData, fn) {
    let uid = paramsData.uid;
    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_pdd.user_pay_list + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        })
    }
}

/**
 * 获取提款纪录
 * @param paramsData
 * @param fn
 */
export function getOrderBySumbit_pdd(paramsData, fn) {
    let uid = paramsData.uid;

    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_pdd.get_order_by_sumbit;

        post(url, param).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 订单详情下载xls
 * @param paramsData
 * @param fn
 */
export function getOrderByFinishXls_pdd(paramsData, fn) {
    let pid = paramsData.pid;
    let stime = paramsData.stime;

    if (pid && stime) {
        let randomNum = common.getRandom();
        let _md5 = md5(pid + stime + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_pdd.get_order_by_finish_xls;

        post(url, param).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 提交提款
 * @param paramsData
 * @param fn
 */
export function getUserSubmit_pdd(paramsData, fn) {
    let uid = paramsData.uid;
    let truename = paramsData.u_truename;
    let account = paramsData.u_account;
    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + truename + account + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);
        this.$log(param)
        let url = common_pdd.user_submit;
        post(url, param).then(function (response) {
            if (fn) {
                fn(response);
            }
        })
    }
}

/**
 * 获取系统配置
 * @param paramsData
 * @param fn
 */
export function getSubConfig_pdd(fn) {

    let randomNum = common.getRandom();
    let _md5 = md5(randomNum + common.key).toLowerCase();
    let paramsData = {
        md5: _md5,
        rnum: randomNum
    };

    let param = formatData(paramsData);
    this.$log("getSubConfig param = " + param)
    let url = common_pdd.sub_config + '?' + param;
    get(url).then(function (response) {
        if (fn) {
            fn(response)
        }
    })
}

/**
 * 多多客是否授权备案接口
 * @param paramsData
 * @param fn
 */
export function checkAuthRecord_pdd(paramsData, fn) {
    let pid = paramsData.pid;
    if (pid) {
        // let randomNum = common.getRandom();
        // let _md5 = md5(pid + randomNum + common.key).toLowerCase();
        // paramsData.md5 = _md5;
        // paramsData.rnum = randomNum;

        let url = common_pdd.check_auth_record;

        postJson(url, paramsData).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 获取多多客绑定授权备案接口数据
 * @param paramsData
 * @param fn
 */
export function getBindAuthRecordData_pdd(paramsData, fn) {
    let pid = paramsData.pid;
    if (pid) {
        // let randomNum = common.getRandom();
        // let _md5 = md5(pid + randomNum + common.key).toLowerCase();
        // paramsData.md5 = _md5;
        // paramsData.rnum = randomNum;

        let url = common_pdd.get_bind_auth_record_data;

        postJson(url, paramsData).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })
    }
}